<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('weekly.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'weeklies' }">{{ $t('weekly.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-button-toolbar>
          <b-button-group>
            <b-button variant="primary" @click="showWeeklySubscriptionForm()">
              {{ $t('weekly.list.button.subscribe-or-unsubscribe.label') }}
            </b-button>
          </b-button-group>
        </b-button-toolbar>
        <weekly-subscription-form></weekly-subscription-form>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-form @submit="submitParam">
          <b-input-group size="lg">
            <b-form-select
              v-model="filter.of_year"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">{{ $t('weekly.list.search-bar.year-selector.hint') }}</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in years">{{ $t('weekly.list.search-bar.year-selector.option.label', { year: n }) }}</b-form-select-option>
            </b-form-select>
            <b-form-select
              v-model="filter.of_month"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">{{ $t('weekly.list.search-bar.month-selector.hint') }}</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in 12">{{ $t('weekly.list.search-bar.month-selector.option.label', { month: n }) }}</b-form-select-option>
            </b-form-select>
            <b-input-group-append>
              <b-button type="submit" variant="primary">{{ $t('weekly.list.search-bar.search-button.label') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3">
        <div class="col">
          <b-list-group>
            <b-list-group-item
              class="d-flex w-100 justify-content-between align-items-center"
              v-for="weekly in weeklies"
            >
                <h5>
                  <span class="d-inline-block">{{ weekly.publication_date.slice(0, 10) }}</span>
                &nbsp;<span class="d-none d-sm-inline-block">/</span>&nbsp;
                <span class="d-inline-block">{{ $t('issue', { issue: weekly.issue }) }}</span>
                <div v-if="weekly.topic">「{{ weekly.topic }}」</div>
              </h5>
              <b-button
                squared
                variant="outline-primary"
                target="_blank"
                :href="weekly.url"
              >{{ $t('weekly.list.button.read.label') }}</b-button>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
            align="center"
            size="lg"
          ></b-pagination>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'

import lodash from 'lodash'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonGroupPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { ButtonToolbarPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import WeeklySubscriptionForm from '@/components/forms/WeeklySubscriptionForm'

import i18n from '@/plugins/i18n.js'

import WeeklyApiService from '@/services/budaedu-api-services/weekly-api-service.js'

Vue.use(lodash)
Vue.use(BreadcrumbPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(ButtonPlugin)
Vue.use(ButtonToolbarPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(ListGroupPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)

Vue.use(WeeklyApiService)

export default {
  i18n,
  name: 'weeklies',
  data() {
    return {
      is_loading: false,
      filter: {
        of_year: '',
        of_month: ''
      },
      years: [],
      per_page: 10,
      page: 1,
      total: 0,
      weeklies: []
    }
  },
  methods: {
    submitParam(event) {
      event.preventDefault()
      this.page = 1
      this.setWeekliesAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setWeekliesAndPaging()
    },
    async setYears() {
      this.years = await this.$weeklyApiService.getListOfPublicationYear()
    },
    showWeeklySubscriptionForm() {
      this.$bvModal.show("weekly-subscription-form")
    },
    async setWeekliesAndPaging() {
      this.is_loading = true
      this.weeklies = []
      try {
        let params = stringify({
          filter: lodash.pickBy(this.filter, value => value !== ''),
          per_page: this.per_page,
          page: this.page,
          order: 'publication_date,desc'
        }).substr(1)
        const items = await this.$weeklyApiService.query(params)

        this.weeklies = items.data
        this.total = items.meta.total
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setWeekliesAndPaging()
    await this.setYears()
  },
  components: {
    WeeklySubscriptionForm
  },
  metaInfo() {
    return {
      title: this.$t('weekly.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>